import { createAction, props } from '@ngrx/store';
import { Notification } from '@core/models/notification/notification';

export const ADD_NOTIFICATION = '[Notifications] Add Notification';
export const ADD_NOTIFICATION_SUCCESS = '[Notifications] Add Notification Success';
export const REMOVE_NOTIFICATION = '[Notifications] Remove Notification';
export const REMOVE_NOTIFICATION_SUCCESS = '[Notifications] Remove Notification Success';
export const REMOVE_ALL_NOTIFICATIONS = '[Notifications] Remove All Notifications';

export const addNotification = createAction(ADD_NOTIFICATION, props<{ payload: Notification }>());
export const addNotificationSuccess = createAction(ADD_NOTIFICATION_SUCCESS, props<{ payload: Notification }>());
export const removeNotification = createAction(REMOVE_NOTIFICATION, props<{ payload: Notification }>());
export const removeNotificationSuccess = createAction(REMOVE_NOTIFICATION_SUCCESS, props<{ payload: Notification }>());
export const removeAll = createAction(REMOVE_ALL_NOTIFICATIONS);

